import { MortgageCampaignLoader } from 'common/module/mortgage/campaign-loader';
import { AssetLoaderCssService } from 'common/service/asset-loader-css/service';

export function MortgageCampaignLoaderFactory(): MortgageCampaignLoader {
  return new MortgageCampaignLoader(AssetLoaderCssService());
}
